import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { RelativityDatasourceService } from '@core/services/relativity-datasource.service';

@Injectable()
export class RelativityDataSourceInterceptor implements HttpInterceptor {
  constructor(
    private readonly relativityDatasourceService: RelativityDatasourceService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return defer(() => {
      const datasource = this.relativityDatasourceService.datasource();

      let modifiedRequest = request;

      // Add datasource as query parameter if it's not null
      if (datasource !== null) {
        const params = request.params.set('relativity_datasource', datasource);
        modifiedRequest = request.clone({ params });
      }

      return next
        .handle(modifiedRequest)
        .pipe(
          catchError((err) => {
            throw err;
          })
        )
        .pipe(
          finalize(() => {
            // Finalization logic if needed
          })
        );
    });
  }
}
